import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import {
  type ICallingListResponse,
  type IResponseFullAICallingAgent,
} from 'entities/AICalling/api/types'
import { toggleCallingActive } from 'pages/chatbot/pages/calling/actions/toggleActive/toggleActive'

type Props = {
  item: ICallingListResponse
  onSuccessUpdate: (response: IResponseFullAICallingAgent) => void
  size?: ISwitchActionProps['size']
  className?: string
}

export const CallingActiveToggle = observer(
  ({ item, onSuccessUpdate, size = 'small', className }: Props) => (
    <div className={className}>
      <Tooltip
        label={item.status === 'draft' && 'Complete required info to enable'}
        placement={'top'}
      >
        <SwitchAction
          size={size}
          active={item.status === 'active'}
          disabled={item.status === 'draft'}
          onTrigger={() => toggleCallingActive(item, onSuccessUpdate)}
          ariaLabel={`CallingActiveToggle-${item.id}`}
        />
      </Tooltip>
    </div>
  )
)
